<template>
  <div id="app" class="h-fill">
    <keep-alive>
      <router-view v-if="$route.meta.KeepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.KeepAlive"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {}
  },
  methods: {},
  mounted() {

  },
  created() {

  },
}
</script>

<style>

</style>
